<div class="chipListContainer">
    @if (filterParams?.tags != null || filterParams?.tags != []) {
        <mat-chip-set class="chipList" aria-label="Tags selected">
            <!-- SearchBar -->
            <mat-form-field class="searchBar">
                <mat-icon class>search</mat-icon>
                <input matInput placeholder="Rechercher" [formControl]="searchQuery" (keyup.enter)="onSearch()" />
                @if (searchQuery.value != null) {
                    @if (searchQuery.value === initSearch) {
                        <mat-icon class="clearSearchIcon" matSuffix (click)="searchQuery.setValue(null); onSearch()">
                            close
                        </mat-icon>
                    } @else {
                        <span matSuffix class="launchSearchText" (click)="onSearch()"> Rechercher </span>
                    }
                }
            </mat-form-field>
            <!-- Ajouter un filtre -->
            <mat-chip class="newTag" [matMenuTriggerFor]="filterMenu">
                <span class="material-icons addBtn">add</span>
                <span class="text">Filtrer</span>
            </mat-chip>

            <!-- Tags -->
            @for (tagId of filterParams.tags; track $index) {
                <mat-chip selected color="primary" matTooltip="Supprimer le tag" (click)="removeTag(tagId)">
                    <mat-icon class="chipCatIcon">{{ getTagIcon(tagId) }}</mat-icon>
                    <span color="primary"> {{ getTagName(tagId) }}</span>
                    <span
                        style="height: unset !important"
                        matChipRemove
                        (click)="removeTag(tagId)"
                        class="material-icons"
                    >
                        cancel
                    </span>
                </mat-chip>
            }

            <!-- Tags / Face -->
            @for (tagId of filterParams.faceIds; track $index) {
                <mat-chip selected color="primary" matTooltip="Supprimer le tag" (click)="removeTag(tagId)">
                    <mat-icon class="chipCatIcon">{{ getTagIcon(tagId) }}</mat-icon>
                    <span color="primary"> {{ getTagName(tagId) }}</span>
                    <span
                        style="height: unset !important"
                        matChipRemove
                        (click)="removeTag(tagId)"
                        class="material-icons"
                    >
                        cancel
                    </span>
                </mat-chip>
            }

            <!-- MatMenu pour le filtrage -->
            <mat-menu #filterMenu="matMenu" class="tagMenu" (closed)="onFilterMenuClosed()">
                @for (cat of categoriesAndTag; track $index) {
                    <button class="cat" mat-menu-item [matMenuTriggerFor]="menuRefs.get(cat.n)">
                        @if (cat.c != null) {
                            <mat-icon class="catIcon">{{ cat.c }}</mat-icon>
                        }
                        <span class="catName">{{ cat.n }}</span>
                    </button>
                }
            </mat-menu>

            <!-- Boucle pour générer les menus associés -->
            @for (cat of categoriesAndTag; track $index) {
                <mat-menu #menuRef="matMenu" class="subTagMenu">
                    @for (tag of cat.t; track $index) {
                        <div style="position: relative">

                            <!-- Catégorie déjà sélectionnée -->
                            @if (filterParams.tags.indexOf(tag.i) != -1 || filterParams.faceIds.indexOf(tag.i) != -1) {
                                <mat-icon class="checkIcon">done</mat-icon>
                            }

                            <button
                                mat-menu-item
                                class="subCat"
                                [ngClass]="{
                                    selectedTag:
                                        filterParams.tags.indexOf(tag.i) != -1 ||
                                        filterParams.faceIds.indexOf(tag.i) != -1,
                                }"
                                (click)="$event.stopPropagation(); selectSubMenu(tag, cat)"
                            >
                                <span class="subCatSpan">{{ tag.n }} </span>
                            </button>
                        </div>
                    }
                </mat-menu>
            }
        </mat-chip-set>
    }
</div>
